import Cart from '@/cart';
import EventBus from '@/event-bus';
import Shop from '@/shop';
import accessories from '@/ui/ui_accessories';
import _Singleton from '@/tools/singleton';
import jquery from 'jquery';
import _toFinite from 'lodash/toFinite';
import _forEach from 'lodash/forEach';

import options from '@/ui/ui_product/default-selectors.json';
import defaultSettings from '@/ui/ui_product/default-settings.json';

/**
 * @class
 * @private
 *
 * @description
 * DOM + Product
 */
const ProductDOM = function() {
  this._init();
};

/**
 * Инициализация
 * @method
 * @private
 *
 * @return {void}
 */
ProductDOM.prototype._init = function() {
  const self = this;
  self.options = options;
  self.defaultSettings = defaultSettings;
  self.accessories = accessories;

  EventBus.subscribe('update_variant:insales:product', function(productData) {
    if (productData.action && productData.action.product) {
      self.productNode = productData.action.product[0];
      self.locale = Shop.config.config.locale;

      self.accessories._renderAccessories(self.productNode, productData.action);
      self._renderPrices(productData);
      self._renderSku(productData);
      self._renderAvailable(productData);
      self._renderPreorderInfo(productData, self.productNode);
      self._renderBnplPrices(productData);
      self._renderMarketplaceLinks(productData);

      if (jquery(self.productNode).find(self.options.priceFromCart.attr)) {
        self._renderPriceFromCart(productData);
      } else {
        self.accessories.priceWithAccessories(self.productNode, productData);
      }
    }
  });

  EventBus.subscribe('update_items:insales:cart', function(cartData) {
    self._updatePriceFromCart(cartData);
  });

  jquery(document).on('click', self.options.preorder.attr, function() {
    const product_title = jquery(this).attr(self.options.preorderProductName.value);
    const variant_title = jquery(this).attr(self.options.preorderVariant.value);
    const accessories_title = jquery(this).attr(self.options.preorderAccessories.value);

    const event_data = {
      product: product_title,
      variant: variant_title,
      accessories: accessories_title
    };

    EventBus.publish('show-preorder:insales:ui_product', event_data);
  });
};

/**
 * @private
 *
 * @description
 * Рендер цен
 *
 * @param {Object} productData - данные о товаре
 * @return {void}
 */
ProductDOM.prototype._renderPrices = function(productData) {
  const self = this;

  const price_node = jquery(self.productNode).find(self.options.price.attr);
  const old_price_node = jquery(self.productNode).find(self.options.oldPrice.attr);

  const has_zero_price_text_attr = price_node.is(self.options.zeroPriceText.attr);
  const zero_price_text = price_node.data(self.options.zeroPriceText.data) || self._getMessageByLocale('zeroPriceText');

  const sale_value_node = jquery(self.productNode).find(self.options.saleValue.attr);
  const sale_value_settings = sale_value_node.data(self.options.saleValue.data);

  let sale_value_before_symbol = '';

  sale_value_before_symbol = (sale_value_settings && sale_value_settings.beforeSymbol) ?
    sale_value_settings.beforeSymbol : self._getMessageByLocale('beforeSymbol');

  const price = (productData.action && productData.action.price) ? productData.action.price : productData.price;
  const oldPrice = productData.old_price ? productData.old_price : price;

  if (_toFinite(price) === 0 && has_zero_price_text_attr) {
    price_node.html(zero_price_text);
    old_price_node.html('');
    sale_value_node.html('');
    jquery(self.productNode)
      .removeClass(self.defaultSettings.classes.withOldPrice)
      .removeClass(self.defaultSettings.classes.withSaleValue)
      .addClass(self.defaultSettings.classes.withoutOldPrice)
      .addClass(self.defaultSettings.classes.hasZeroPrice);

    return;
  }

  price_node.html(Shop.money.format(price));

  if (_toFinite(oldPrice) && _toFinite(oldPrice) > _toFinite(price)) {
    old_price_node.html(Shop.money.format(oldPrice));

    if (sale_value_node) {
      const sale_value = Math.round(100 - _toFinite(price) * 100 / _toFinite(oldPrice));

      if (sale_value > 0) {
        sale_value_node.html(sale_value_before_symbol + sale_value + '%');
        jquery(self.productNode).addClass(self.defaultSettings.classes.withSaleValue);
      } else {
        sale_value_node.html('');
      }
    }

    jquery(self.productNode)
			.removeClass(self.defaultSettings.classes.withoutOldPrice)
			.addClass(self.defaultSettings.classes.withOldPrice);
  } else {
    old_price_node.html('');

    if (sale_value_node) { sale_value_node.html(''); }

    jquery(self.productNode)
			.removeClass(self.defaultSettings.classes.withOldPrice)
			.removeClass(self.defaultSettings.classes.withSaleValue)
      .removeClass(self.defaultSettings.classes.hasZeroPrice)
			.addClass(self.defaultSettings.classes.withoutOldPrice);
  }
};

/**
 * @private
 * @description
 * Рендер bnpl цен для каждого варианта
 * @param {Object} productData - данные о варианте товара
 * @return {void}
 */
ProductDOM.prototype._renderBnplPrices = function(productData) {
  const sberMinPrice = Shop.config.config.sber_bnpl_min_amount;
  const self = this;

  let price = productData.sber_bnpl_price;

  if (!productData.sber_bnpl_price) {
    price = productData.action.price / 4;
  }

  const bnplPriceNodes = Array.from(document.querySelectorAll(self.options.sberBnplPrice.attr));

  bnplPriceNodes.forEach(bnplPriceNode => {
    const parentNode = bnplPriceNode.closest('[data-product-id]');
    const productId = Number(parentNode.getAttribute('data-product-id'));

    if (!parentNode || productId !== productData.product_id) {
      self._handleBnplButtonVisibility(price);

      return;
    }

    const target = self.productNode.querySelector(self.options.sberBnplPrice.attr);

    if (!target) { return; }

    if (productData.action.price < sberMinPrice) {
      target.innerHTML = Shop.money.format(Math.floor(sberMinPrice / 4), true);

      return;
    }

    target.innerHTML = Shop.money.format(Math.floor(price), true);
  });

  self._handleBnplButtonVisibility(price);
};

/**
 * @private
 * @description
 * Скрывает кнопку "Плати частями" если цена товара больше максимальной суммы для рассрочки
 * @param {Number} price - цена товара
 * @return {void}
 */
ProductDOM.prototype._handleBnplButtonVisibility = function(price) {
  const self = this;
  const sberMaxPrice = Shop.config.config.sber_bnpl_max_amount;
  const bnplButton = self.productNode.querySelector(self.options.bnplButton.attr);

  if (!bnplButton) { return; }

  if (price > sberMaxPrice) {
    bnplButton.style.visibility = 'hidden';
    bnplButton.style.position = 'absolute';

    return;
  }

  bnplButton.style.visibility = 'visible';
  bnplButton.style.position = 'static';
};

/**
 * @private
 *
 * @description
 * Рендер цены из данных Корзины
 *
 * @param {Object} productData - данные о товаре
 * @return {void}
 */
ProductDOM.prototype._renderPriceFromCart = function(productData) {
  const self = this;

  let price = '';
  let is_variant_in_cart = false;
  let rounded_price = 0;
  // Достаём опции из карточки товара
  const accessoryItems = Array.from(document.querySelectorAll(self.accessories.options.accessoryValuesItemId.attr));

  // Если у варианта товара есть опции (аксессуары), то получаем и рендерим цену на уровне компонента аксессуаров
  if (accessoryItems.length) {
    self.accessories.priceWithAccessories(self.productNode, productData);

    return;
  }

  _forEach(Cart.order.order_lines, function(value) {
    if (productData.id !== value.variant_id) { return; }

    price = value.sale_price;
    is_variant_in_cart = true;
  });

  if (!is_variant_in_cart) {
    price = (productData.action && productData.action.price) ? productData.action.price : productData.price;
  }

  if (!price && price !== 0) { return; }

	// Делаем округлнеие до 2х знаков, так как прилетает с бэка тысячные
  rounded_price = Math.round(price * 100) / 100;

  const price_node = jquery(self.productNode).find(self.options.priceFromCart.attr);

  const has_zero_price_text_attr = price_node.is(self.options.zeroPriceText.attr);
  const zero_price_text = price_node.data(self.options.zeroPriceText.data) || self._getMessageByLocale('zeroPriceText');

  if (rounded_price === 0 && has_zero_price_text_attr) {
    price_node.html(zero_price_text);

    jquery(self.productNode)
      .addClass(self.defaultSettings.classes.hasZeroPrice);

    return;
  }

  jquery(self.productNode).removeClass(self.defaultSettings.classes.hasZeroPrice);

  price_node.html(Shop.money.format(rounded_price));
};

/**
 * @private
 *
 * @description
 * Обновление цены из данных Корзины
 *
 * @param {Object} cartData - данные о корзине
 * @return {void}
 */
ProductDOM.prototype._updatePriceFromCart = function(cartData) {
  const self = this;

  _forEach(cartData.action.currentItems, (cartItemData) => {
    Array.from(document.querySelectorAll(`[data-product-id="${cartItemData.product_id}"]`)).forEach((productNode) => {
      // Достаём выбранные опции из карточки товара
      const curVariantIdField = productNode.querySelector('[name="variant_id"]');
      const curVariantId = curVariantIdField ? parseInt(curVariantIdField.value) : 0;
      const accessoryItems = Array.from(document.querySelectorAll(self.accessories.options.accessoryValuesItemId.attr));

      if (curVariantId !== cartItemData.variant_id) { return; }

      // Если у варианта товара есть опции (аксессуары), то получаем и рендерим цену на уровне компонента аксессуаров
      if (Object.keys(accessoryItems).length) {
        self.accessories.priceWithAccessories(productNode, cartItemData, true);

        return;
      }

      Array.from(productNode.querySelectorAll(self.options.priceFromCart.attr)).forEach(priceNode => {
        const hasZeroPriceTextAttr = priceNode.hasAttribute(self.options.zeroPriceText.value);
        const zero_price_text = priceNode.dataset[self.options.zeroPriceText.data] || self._getMessageByLocale('zeroPriceText');

        if (cartItemData.sale_price === 0 && hasZeroPriceTextAttr) {
          priceNode.innerHTML = zero_price_text;

          return;
        }

        priceNode.innerHTML = Shop.money.format(cartItemData.sale_price);
      });
    });
  });
};

/**
 * @private
 *
 * @description
 * Рендер артикула
 *
 * @param {Object} productData - данные о товаре
 * @return {void}
 */
ProductDOM.prototype._renderSku = function(productData) {
  const self = this;

  const sku_node = jquery(self.productNode).find(self.options.sku.attr);
  const sku_settings = sku_node.data(self.options.sku.data);

  let sku_label = '';

  sku_label = (sku_settings && sku_settings.skuLabel) ?
		sku_settings.skuLabel : self._getMessageByLocale('skuLabel');

  if (productData.sku) {
    if (sku_label == '') {
      sku_node.html('<span class="' + self.defaultSettings.classes.skuValue + '">' + productData.sku + '</span>');
    } else {
      sku_node.html('<span class="' + self.defaultSettings.classes.skuLabel + '">' + sku_label + '</span>' +
				'<span class="' + self.defaultSettings.classes.skuValue + '">' + productData.sku + '</span>');
    }

    jquery(self.productNode)
			.removeClass(self.defaultSettings.classes.withoutSku)
			.addClass(self.defaultSettings.classes.withSku);
  } else {
    sku_node.html('');

    jquery(self.productNode)
			.removeClass(self.defaultSettings.classes.withSku)
			.addClass(self.defaultSettings.classes.withoutSku);
  }
};

/**
 * @private
 *
 * @description
 * Рендер информации о наличии
 *
 * @param {Object} productData - данные о товаре
 * @return {void}
 */
ProductDOM.prototype._renderAvailable = function(productData) {
  const self = this;

  const available_node = jquery(self.productNode).find(self.options.available.attr);
  const available_settings = available_node.data(self.options.available.data);

  let available_text = '';
  let not_available_text = '';

  available_text = (available_settings && available_settings.availableText) ?
		available_settings.availableText : self._getMessageByLocale('availableText');

  not_available_text = (available_settings && available_settings.notAvailableText) ?
		available_settings.notAvailableText : self._getMessageByLocale('notAvailableText');

  if (productData.available) {
    available_node.html(available_text);

    jquery(self.productNode)
			.removeClass(self.defaultSettings.classes.notAvailable)
			.addClass(self.defaultSettings.classes.isAvailable);
  } else {
    available_node.html(not_available_text);

    jquery(self.productNode)
			.removeClass(self.defaultSettings.classes.isAvailable)
			.addClass(self.defaultSettings.classes.notAvailable);
  }
};

/**
 * @private
 *
 * @description
 * Рендер информации для предзаказа
 *
 * @param {Object} productData - данные о товаре
 * @return {void}
 */
ProductDOM.prototype._renderPreorderInfo = function(productData) {
  const self = this;

  const preorder_btn_node = jquery(self.productNode).find(self.options.preorder.attr);

  if (!preorder_btn_node) { return; }

  preorder_btn_node.attr(self.options.preorderProductName.value, productData.action.productJSON.title);
  preorder_btn_node.attr(self.options.preorderVariant.value, productData.title);

  if (Object.keys(productData.action.productJSON.accessories).length === 0) { return; }

  self._addAccessoriesDataToNode(preorder_btn_node);

  EventBus.subscribe('accessory_value_changed:insales:ui_accessories', function(accessories_data) {
    if (self.productNode.dataset.productId == accessories_data.productNode.dataset.productId) {
      self._addAccessoriesDataToNode(preorder_btn_node);
    }
  });
};

/**
 * @private
 *
 * @description
 * Рендер опций товара для предзаказа
 *
 * @param {Object} btn_node - нода кнопки
 * @return {Void}
 */
ProductDOM.prototype._addAccessoriesDataToNode = function(btn_node) {
  const self = this;

  const activeAccessories = self.accessories._activeAccessories(self.productNode);
  if (activeAccessories) {
    btn_node.attr(self.options.preorderAccessories.value, JSON.stringify(activeAccessories));
  }
};

/**
 * @private
 *
 * @description
 * Получение текста из словаря базовых сообщений
 *
 * @param {String} messageName - название сообщения
 * @return {String} текст сообщения
 */
ProductDOM.prototype._getMessageByLocale = function(messageName) {
  const self = this;

  if (typeof self.locale !== 'undefined') {
    let result_message = self.defaultSettings[messageName][self.locale];

    if (typeof result_message === 'undefined') {
      result_message = self.defaultSettings[messageName].ru;
    }

    return result_message;
  }

  return self.defaultSettings[messageName].ru;
};

/**
 * @private
 *
 * @description
 * При изменении варианта меняем значение атрибута href для ссылки на маркетплейс и вешаем на форму класс with-marketplace-links, если есть хотя бы одна ссылка на МП
 *
 * @param {String} variantData - вариант товара
 * @return {void}
 */
ProductDOM.prototype._renderMarketplaceLinks = function(variantData) {
  const self = this;

  const ozonLinks = this.productNode.querySelectorAll(this.options.ozonLink.attr);
  const wildberriesLinks = this.productNode.querySelectorAll(this.options.wildberriesLink.attr);

  if (variantData.ozon_link || variantData.wildberries_link) {
    self.productNode.classList.add(self.defaultSettings.classes.withMarketplaceLinks);
  } else {
    self.productNode.classList.remove(self.defaultSettings.classes.withMarketplaceLinks);
  }

  self.setMarketplaceLinks(ozonLinks, variantData.ozon_link);
  self.setMarketplaceLinks(wildberriesLinks, variantData.wildberries_link);
};

ProductDOM.prototype.setMarketplaceLinks = (links, dataLink) => {
  links.forEach(link => {
    if (dataLink) {
      link.setAttribute('href', dataLink);
      link.style.display = '';
    } else {
      link.setAttribute('href', '');
      link.style.display = 'none';
    }
  });
};

export default _Singleton(ProductDOM).getInstance();
